<template>
	<div style="width: 100%;height: 100%;">
		<div>
			<el-tabs @tab-add="tabAdd" addable v-model="editableTabsValue" type="card" @edit="handleTabsEdit">
				<el-tab-pane :key="index" v-for="(item, index) in form.classfiy" :label="item.name" :name="item.value">
					<el-tabs v-model="classfiyTextValue" type="card" @edit="handleTabsEdit">
						<el-tab-pane :key="textIndex" v-for="(textItem, textIndex) in item.classfiyTitList"
							:label="textItem.languageName" :name="textItem.language">
							<div style="display: flex;align-items: center;">
								<div style="width: 100px;">配置分类名称:</div>
								<el-input @input="changeclassfiyTit($event,textItem,index)" v-model="textItem.text"
									placeholder="请输入标题"></el-input>
							</div>
						</el-tab-pane>
					</el-tabs>


					<el-tabs style="margin-top: 20px;" v-model="textValue" type="card" @edit="handleTabsEdit">
						<el-tab-pane :key="textIndex" v-for="(textItem, textIndex) in item.titList"
							:label="textItem.languageName" :name="textItem.language">
							<div style="display: flex;align-items: center;">
								<div style="width: 100px;">配置标题:</div>
								<el-input v-model="textItem.text" placeholder="请输入标题"></el-input>
							</div>
						</el-tab-pane>
					</el-tabs>
					<div style="display: flex;align-items: center;margin-top: 20px;">
						<div style="width: 100px;">配置商品:</div>
						<el-select v-model="goodsValue" filterable remote :remote-method="remoteMethod" reserve-keyword
							placeholder="请输入关键词" @change="changeGoodsName" :loading="loading">
							<el-option v-for="goodsItem in item.goodsList" :key="goodsItem.id" :label="goodsItem.name"
								:value="goodsItem.id">
							</el-option>
						</el-select>
					</div>
					<div>
						<div style="margin-top: 20px;" v-for="(selectitem,selectiIndex) in item.selectList"
							:key="selectiIndex">
							<div style="display: flex;">
								<div>
									{{selectitem.name}}
								</div>
								<div @click="delSelect(index,selectiIndex)"
									style="margin-left: 20px;color: #55aaff ;cursor: pointer;">删除</div>
							</div>
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
		<div style="width: 100%;display: flex;justify-content: flex-end;margin-top: 20px;">
			<span slot="footer" class="dialog-footer">
				<el-button @click="cancelGoods">取 消</el-button>
				<el-button type="primary" @click="confirmGoods">确 定</el-button>
			</span>
		</div>
	</div>
</template>

<script>
	import {
		getAutocomplete
	} from '../../api/all.js'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex';
	import lodash from 'lodash';
	export default {
		props: {
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				loading: false,
				goodsValue: "",
				textValue: "zh_cn",
				classfiyTextValue: "zh_cn",
				editableTabsValue: "1",
				form: {
					list: [{
							language: "zh_cn",
							languageName: "中文",
							text: ""
						},
						{
							language: "en",
							languageName: "英文",
							text: ""
						}
					],
					classfiy: [{
						value: "1",
						name: "tabs1",
						goodsList: [],
						selectList: [],
						titList: [{
								language: "zh_cn",
								languageName: "中文",
								text: ""
							},
							{
								language: "en",
								languageName: "英文",
								text: ""
							}
						],
						classfiyTitList: [{
								language: "zh_cn",
								languageName: "中文",
								text: ""
							},
							{
								language: "en",
								languageName: "英文",
								text: ""
							}
						],

					}],
				}


			}
		},
		computed: {},
		async mounted() {
			console.log('mountedselectdItemselectdItem', this.selectdItem)
			this.form = lodash.cloneDeep(this.selectdItem.compontChildren[0].data)
			this.setclassfiyTit()
			this.remoteMethod('')
		},
		methods: {
			setclassfiyTit() {
				this.form.classfiy.forEach(classfiyItem => {
					let str = ""
					classfiyItem.classfiyTitList.forEach(tit => {
						console.log('setclassfiyTit', tit)
						if (tit.text != '' && str == '') {
							str = tit.text
						}
					})

					if (str) {
						classfiyItem.name = str
					}
					if (classfiyItem.name == '') {
						classfiyItem.name = 'tabs' + classfiyItem.value
					}


				})
				this.$forceUpdate()

			},
			changeclassfiyTit(e, textItem) {
				console.log('changeclassfiyTit ', e)
				console.log('changeclassfiyTit ', textItem)
				console.log('classfiy', this.form.classfiy)
				this.$nextTick(() => {
					this.setclassfiyTit()
				})


			},
			tabAdd() {
				console.log(12)
				this.form.classfiy.push({
					value: (this.form.classfiy.length + 1) + '',
					name: "tabs" + (this.form.classfiy.length+ 1) ,
					goodsList: [],
					selectList: [],
					titList: [{
							language: "zh_cn",
							languageName: "中文",
							text: ""
						},
						{
							language: "en",
							languageName: "英文",
							text: ""
						}
					],
					classfiyTitList: [{
							language: "zh_cn",
							languageName: "中文",
							text: ""
						},
						{
							language: "en",
							languageName: "英文",
							text: ""
						}
					],

				})
				this.remoteMethod()
			},
			delSelect(index, selectiIndex) {
				this.form.classfiy[index].selectList.splice(selectiIndex, 1)
			},
			async remoteMethod(e) {
				this.loading = true
				let wsid = this.$cookies.get("wsid")
				let data = await getAutocomplete({
					wsid,
					name: e
				})
				console.log('remoteMethod', data)
				this.form.classfiy.forEach(item => {
					item.goodsList = data.data.data
				})
				this.loading = false
			},
			changeGoodsName(e) {
				console.log('changeGoodsName', e)
				this.form.classfiy.forEach(item => {
					if (item.value == this.editableTabsValue) {
						let isexit = false
						item.selectList.forEach(selectItem => {
							if (selectItem.id == e) {
								isexit = true
							}
						})
						if (!isexit) {
							item.goodsList.forEach(goodItem => {
								if (goodItem.id == e) {
									item.selectList.push(goodItem)
								}
							})
						}

					}
				})
				console.log('this.form.classfiy', this.form.classfiy)

				this.$nextTick(() => {
					this.goodsValue = ""
				})
			},
			cancelGoods() {
				this.$emit('cancelGoods')
			},
			confirmGoods() {
				this.$emit('confirmGoods', this.form)
			},
			handleTabsEdit() {

			}

		}
	}
</script>

<style>
</style>